// sessionStorage
export function getItem(item) {
    return localStorage.getItem(item)
}

export function setItem(key, item) {
    return localStorage.setItem(key, item)
}

export function removeItem(item) {
    return localStorage.removeItem(item)
}



// WEBPACK FOOTER //
// ./src/utility/auth.js